package com.example.readingnotes.presentation.postdetail

sealed interface PostDetailEvent {
    data class OnAppear(
        val postId: Int,
    ) : PostDetailEvent

    data class OnAuthorNameChanged(
        val text: String,
    ) : PostDetailEvent

    data class OnCommentContentChanged(
        val text: String,
    ) : PostDetailEvent

    data object OnCommentSubmit : PostDetailEvent

    data object OnShareClick : PostDetailEvent

    data object OnCopyClick : PostDetailEvent

    // SSE: Reload comments when new comment is created
    data class OnLoadComments(
        val postId: Int,
    ) : PostDetailEvent
}
